const darkColors = {
  accent: '#F9BA42',
  accentBg: 'rgba(249,186,66,0.08)',
  accentBorder: 'rgba(249,186,66,0.22)',
  accentDark: '#E0A030',

  alpha50: 'rgba(17, 17, 17, 0.5)',
  alpha60: 'rgba(255, 255, 255, 0.6)',
  bg: '#05080F',
  bgAccent: '#0E1222',
  bgCard: '#0A0E1A',
  bgCard2: '#0E1222',
  bgCard3: '#141828',

  bgHover: '#0E1222',
  bgTopbar: '#05080F',
  black: '#000000',
  blue: '#3B82F6',
  border: '#1A2035',

  borderStrong: '#2E3D5C',
  borderSubtle: '#1A2035',
  darkCharcoal: '#1a1b24',
  darkerLemonYellow: '#ccbf00',
  darkerScarletRed: '#b80000',
  darkGraphite: '#2c2d38',
  darkGreen: '#025740',
  darkGrey: '#3A4560',
  darkRed: '#a20c16',
  employeeProfileGradeMarker: {
    grade1: '#00cc00',
    grade2: '#66cc00',
    grade3: '#ffcc00',
    grade4: '#ff9900',
    grade5: '#ff0000',
  },
  gold: '#F9BA42',
  goldBg: 'rgba(249,186,66,0.08)',

  goldBorder: 'rgba(249,186,66,0.22)',
  goldDark: '#E0A030',
  green: '#4ab756',
  grey: '#AFB1B6',
  groupHeaderTitle: '#7A8AAF',

  iconMuted: '#4A6090',
  lemonYellow: '#FFF201',
  lighterBlack: '#0A0E1A',
  lighterYellow: '#ffbc46',
  lightGreen: '#DDFFF7',
  lightGrey: '#1A2035',
  lightGreyBorder: '#0E1222',
  lightPurple: '#801EFF',

  midnightGray: '#3A4560',
  orange: '#FFA500',
  purple: '#F2E8FF',
  red: '#E05C5C',
  scarletRed: '#eb212e',
  secondaryBlack: '#0E1222',
  shadowCard: '0 8px 24px rgba(0,0,0,0.50)',
  shadowGlow: '0 4px 18px rgba(249,186,66,0.18)',
  shadowGoldGlow: '0 4px 18px rgba(249,186,66,0.20)',
  stroke: '#1A2035',

  textMuted: '#3A4560',
  textPrimary: '#EEF2FF',
  textSecondary: '#7A8AAF',

  whisperGray: '#0E1222',
  white: '#FFFFFF',

  yellow: '#F9BA42',
} as const;

const lightColors = {
  accent: '#F9BA42',
  accentBg: '#FEF3C7',
  accentBorder: '#FDE68A',
  accentDark: '#E59700',

  alpha50: 'rgba(17, 17, 17, 0.5)',
  alpha60: 'rgba(0, 0, 0, 0.6)',
  bg: '#F4F5F7',
  bgAccent: '#F3F4F6',
  bgCard: '#FFFFFF',
  bgCard2: '#F9FAFB',
  bgCard3: '#F3F4F6',

  bgHover: '#F9FAFB',
  bgTopbar: '#05080F',
  black: '#000000',
  blue: '#2563EB',
  border: '#E5E7EB',

  borderStrong: '#D1D5DB',
  borderSubtle: '#E5E7EB',
  darkCharcoal: '#1a1b24',
  darkerLemonYellow: '#C9A000',
  darkerScarletRed: '#7F1D1D',
  darkGraphite: '#111827',
  darkGreen: '#14532D',
  darkGrey: '#6B7280',
  darkRed: '#991B1B',
  employeeProfileGradeMarker: {
    grade1: '#00cc00',
    grade2: '#66cc00',
    grade3: '#ffcc00',
    grade4: '#ff9900',
    grade5: '#ff0000',
  },
  gold: '#F9BA42',
  goldBg: '#FEF3C7',

  goldBorder: '#FDE68A',
  goldDark: '#E59700',
  green: '#059669',
  grey: '#9CA3AF',
  groupHeaderTitle: '#6B7280',

  iconMuted: '#6B7280',
  lemonYellow: '#E8B800',
  lighterBlack: '#F9FAFB',
  lighterYellow: '#E8A020',
  lightGreen: '#0D9488',
  lightGrey: '#E5E7EB',
  lightGreyBorder: '#E5E7EB',
  lightPurple: '#7C3AED',

  midnightGray: '#374151',
  orange: '#EA580C',
  purple: '#EDE9FE',
  red: '#DC2626',
  scarletRed: '#DC2626',
  secondaryBlack: '#F4F5F7',
  shadowCard: '0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px -1px rgba(0, 0, 0, 0.03)',
  shadowGlow: '0 4px 14px rgba(249,186,66,0.15)',
  shadowGoldGlow: '0 4px 14px rgba(249,186,66,0.15)',
  stroke: '#E5E7EB',

  textMuted: '#9CA3AF',
  textPrimary: '#111827',
  textSecondary: '#4B5563',

  whisperGray: '#F9FAFB',
  white: '#FFFFFF',

  yellow: '#F9BA42',
} as const;

export type ThemeColorSet = Widened<typeof darkColors>;

type Widened<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, string>
      ? Record<string, string>
      : never;
};

export const themeColors: ThemeColorSet = darkColors;
export const lightThemeColors: ThemeColorSet = lightColors;
